import { render, staticRenderFns } from "./RecomendacaoModal.vue?vue&type=template&id=3897a25b&scoped=true"
import script from "./RecomendacaoModal.vue?vue&type=script&lang=js"
export * from "./RecomendacaoModal.vue?vue&type=script&lang=js"
import style0 from "./RecomendacaoModal.vue?vue&type=style&index=0&id=3897a25b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3897a25b",
  null
  
)

export default component.exports